import { useState, useEffect, useCallback } from 'react';

export const useCryptoData = (targetCoin) => {
  const [priceData, setPriceData] = useState({});
  const [marketStats, setMarketStats] = useState({ high: 0, low: 0, volume: 0 });
  const [status, setStatus] = useState("Disconnected");
  
  const fetchHistory = useCallback(async () => {
    try {
      // 1000개 요청
      const res = await fetch(`https://crypto-api.oortcloud.me/api/history?code=${targetCoin}&limit=1000`);
      const data = await res.json();

      if (Array.isArray(data) && data.length > 0) {
        setPriceData(prev => ({
          ...prev,
          [targetCoin]: data // 기존 데이터를 덮어쓰지 않고 초기화
        }));
      }
    } catch(e) {
      console.error("History Fetch Error:", e);
    }
  }, [targetCoin]);

  useEffect(() => {

    fetchHistory();

    const ws = new WebSocket(`wss://crypto-api.oortcloud.me/ws?code=${targetCoin}`);

    ws.onopen = () => setStatus("Connected");
    
    ws.onmessage = (event) => {
      try {
        const message = JSON.parse(event.data);
        if (message.type === "history") {
          const formattedHistory = message.data.map(item => ({
            time: item.timestamp / 1000,
            value: item.price
          }));

          formattedHistory.sort((a, b) => a.time - b.time);

          setPriceData(prev => ({
            ...prev,
            [targetCoin]: formattedHistory
          }));
        }

        if (message.type === "ticker") {
          const { code, price, timestamp, high, low, volume_24h } = message.data;
          
          // 현재 타겟 코인의 통계 업데이트
          if (code === targetCoin) {
             setMarketStats({ high, low, volume: volume_24h });
          }

          const timeVal = Math.floor(timestamp / 1000);

          setPriceData(prev => {
            const coinList = prev[code] ? [...prev[code]] : [];
            const lastItem = coinList.length > 0 ? coinList[coinList.length - 1] : null;

            if (lastItem && lastItem.time === timeVal) {
               coinList[coinList.length - 1] = { time: timeVal, value: price };
            } else {
              if (!lastItem || timeVal >= lastItem.time) {
                coinList.push({ time: timeVal, value: price });
               }
            }
            // 메모리 관리: 데이터가 너무 많이 쌓이면 앞부분 삭제
            if (coinList.length > 3000) coinList.shift();

            return { ...prev, [code]: coinList };
          });
        }
      } catch (e) { console.error(e); }
    };

    ws.onclose = () => setStatus("Disconnected");

    return () => {
      if (ws.readyState === 1) ws.close();
    };
  }, [targetCoin, fetchHistory]);

  const currentPrice = priceData[targetCoin] && priceData[targetCoin].length > 0
    ? priceData[targetCoin][priceData[targetCoin].length - 1].value
    : null;

  return { priceData, status, currentPrice, marketStats };
};